import React, { Component } from 'react';

class Manager extends Component {
	render() {
		return (
			<div>
				ManagerArea
			</div>
		);
	}
}

export default Manager;